<template lang="pug">
.ExcelLayerHistory
  .ExcelLayerHistory-content
    .ExcelLayerHistory-header
      .ExcelLayerHistory-header-left Количество записей: {{ layerHistoryCount }}
    .ExcelLayerHistory-table(:class='{ "ExcelLayerHistory-table--pagination": false /*Вернуть true, когда будет постраничка */ }')
      table
        thead
          tr
            th Дата и время
            th id записи
            th Имя пользователя
            th Тип операции
        tbody
          tr(v-for='layerHistoryItem in layerHistory')
            td {{ layerHistoryItem.datetime.toFormat("dd.MM.yyyy HH:mm:ss") }}
            td {{ layerHistoryItem.recordId }}
            td {{ layerHistoryItem.user }}
            td {{ layerHistoryItem.history_type_name }}

    pagination.ExcelLayerHistory-pagination(
      :limit='limit',
      :offset='offset',
      :count='layerHistoryCount',
      @page='goToPage'
    )
  .ExcelLayerHistory-footer.ModalFooter
    .ModalFooter-left
      router-link.Btn.Btn--light.Btn--red(
        tag='button',
        :to='{ name: "excel-layer-list" }'
      ) Вернуться к списку слоев
</template>

<script>
import { DateTime } from 'luxon'

const HISTORY_TYPE_NAME_MAP = {
  create: 'Создание записи',
  delete: 'Удаление записи'
}

export default {
  name: 'ExcelLayerHistory',
  components: {
    pagination: () => import('@/components/Pagination')
  },
  data() {
    return {
      layerHistory: [],
      layerHistoryCount: 0,
      limit: 10,
      offset: 0
    }
  },

  computed: {
    layerId() {
      return this.$route.params.layerId
    },

    permissions() {
      return this.$store.getters.permissions
    }
  },

  watch: {
    '$route.query.offset'() {
      this.loadLayerHistory()
    },
    layerId: {
      handler() {
        this.loadLayerHistory()
      },
      immediate: true
    }
  },

  methods: {
    /**
     * Загрузка записей истории изменений слоя
     */
    loadLayerHistory() {
      this.offset = +this.$route.query.offset || 0
      this.$store
        .dispatch('loadExcelLayerHistory', {
          layerId: this.layerId,
          limit: this.limit, //Пока не влияет, но понадобится для постраничгой загрузки
          offset: this.offset //Пока не влияет, но понадобится для постраничгой загрузки
        })
        .then((response) => {
          //Установка количества
          this.layerHistoryCount = response.body.count

          //Установка массива записей из ответа
          this.layerHistory = response.body.result
            .map((historyItem) => {
              return {
                ...historyItem,
                datetime: DateTime.fromISO(historyItem.datetime),
                recordId: historyItem.data.id,
                history_type_name: HISTORY_TYPE_NAME_MAP[historyItem.operation_type]
              }
            })
            .sort((historyItem1, historyItem2) => {
              return historyItem2.datetime - historyItem1.datetime
            })
        })
    },

    goToPage(offset) {
      this.$router.push({ query: { offset } })
    }
  }
}
</script>

<style scoped lang="scss">
@import '~base';

#app .ExcelLayerHistory {
  --menuColor: #{$grey8};
  --tableBg: #{$grey7};
  --menuLinkColor: #{$blue};
  --tableThColor: #{$grey2};
}

#app[data-theme='dark'] .ExcelLayerHistory {
  --menuColor: #{$grey1};
  --tableBg: #{$black3};
  --menuLinkColor: #{$blue};
  --tableThColor: #{$grey1};
}

.ExcelLayerHistory {
  &-content {
    height: calc(100vh - 137px);
    display: flex;
    flex-direction: column;
  }

  &-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 35px;
    padding: 0 15px;
    color: var(--menuColor);
    font-size: 12px;
    border-bottom: 1px solid var(--delimiter);
    height: 48px;
    flex: 0 0 auto;

    &-right {
      display: flex;
      align-items: center;
    }
  }

  &-pagination {
    height: 84px;
    padding: 26px 15px;
  }

  &-table {
    overflow-y: auto;
    flex: 1 1 0;
    min-height: 0;

    thead th {
      position: sticky;
      color: var(--tableThColor);
      font-size: 12px;
      line-height: 14px;
      top: 0;
      z-index: 1;

      &:first-child {
        z-index: 2;
      }
    }

    tbody {
      font-family: 'Roboto Mono';
      font-size: 12px;
      font-weight: 500;
      line-height: 16px;
    }

    table {
      border-collapse: collapse;
      width: 100%;
    }

    th,
    td {
      padding: 5px 10px;
      background: var(--tableBg);
      font-weight: 400;
      box-shadow: inset 1px -1px var(--appBg), inset 1px 1px var(--appBg), inset -1px -1px var(--appBg), inset -1px 1px var(--appBg);

      label {
        vertical-align: 3px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/excel-layers/ExcelLayerHistory.vue